<!--
 * @Description:
 * @Author: cxh
 * @Date: 2022-05-010 09:55:14
 * @LastEditTime: 2023-03-13 14:50:21
 * @LastEditors: cxh
-->
<template>
  <cos-modal
    v-model:visible="visible"
    :title="editForm.id ? t('arkCode.editArkCodeModalTitle') : t('arkCode.addArkCodeModalTitle')"
    width="600px"
    @ok="handleSubmit"
    :confirmLoading="loading"
  >
    <a-form :model="editForm" ref="formRef" v-if="visible" autocomplete="off">
      <a-form-item
        name="arkCode"
        :label="t('arkCode.arkCode')"
        :rules="[{ required: true, message: t('common.pleaseInput') }]"
      >
        <a-input v-model:value.trim="editForm.arkCode" :placeholder="t('common.pleaseInput')" :maxlength="20" />
      </a-form-item>
      <a-form-item
        name="cosId"
        :label="t('arkCode.relationCustomer')"
        :rules="[{ required: true, message: t('common.pleaseSelect') }]"
      >
        <CustomerSelect v-model:value="editForm.cosId" appId="cos_ofbu" :placeholder="t('common.pleaseSelect')" />
      </a-form-item>
    </a-form>
  </cos-modal>
</template>
<script lang="ts">
import { ref } from 'vue'
import CustomerSelect from '@/components/ClueAndCustomerSelect/src/customer.vue'
import { customerCodeAdd, customerCodeEdit } from '@/api/overseasSales/customerCenter'
import type { FormInstance } from 'ant-design-vue'
import { CustomerCode } from '@/typings/api/customerCenter'
import { message } from '@dc-platform/dc-components'
import { useI18n } from 'vue-i18n'
export default { name: 'editModal' }
</script>
<script setup lang="ts">
const { t } = useI18n()
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const editForm = ref<CustomerCode>({})
const emit = defineEmits(['success'])
const toggle = (row?: CustomerCode) => {
  visible.value = !visible.value
  if (row && (row.id || row.cosId)) {
    editForm.value = { ...row }
  } else {
    editForm.value = {}
  }
}
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const { arkCode, cosId } = editForm.value
    const p = {
      arkCode,
      cosId
    }
    try {
      if (editForm.value.id) {
        await customerCodeEdit({ ...p, id: editForm.value.id })
      } else {
        await customerCodeAdd(p)
      }
      loading.value = false
      emit('success', editForm.value?.id ? 'edit' : 'add')
      message.success(editForm.value?.id ? t('tips.editSuccess') : t('tips.addSuccess'))
      toggle()
    } catch (error) {
      loading.value = false
    }
  })
}
defineExpose({
  toggle
})
</script>

<style lang="scss"></style>
